import React, { Component } from 'react'

import { isMobile } from 'react-device-detect'

import cx from 'classnames'
import styles from './index.scss'

/*
 ********************************************************************
 * Remember Add Default DFP(gpt.js) script in your <head>...</head>. *
 ********************************************************************

  ********************************************************************
  example:
    <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" />
    <script type='text/javascript'>
      window.googletag = window.googletag || {cmd: []};
      googletag.cmd.push(function() {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
      });
    </script>
  ********************************************************************
*/

class DFP extends Component {
  static defaultProps = {
    // EDD mode 只需要給ad unit path size 自動生成廣告
    adUnit: 90969475, // '90969475' '/${adUnit}/${adUnitPath}'
    adUnitPath: '', // 'popdaily_mobile_all_320x50' '/${adUnit}/${adUnitPath}'
    adSize: [], // [[320, 100], [320, 50], [1, 1]]
    // DED mode 需要配合head事先定義slot 在adElementId有值的情況下 將不會自動definedSlof
    adTagName: 'div',
    adElementId: '', // 'div-gpt-ad-1576666380779-0'
    adAutoCollapse: true,
    adTargeting: {},
    adStyle: {},
    className: '',
  }

  constructor(props) {
    super(props)
    const nowTime = new Date().getTime()
    const randomNumber = Math.floor(Math.random() * 100 + 1)
    this.state = {
      slot: null,
      adElementId: props.adElementId || `div-gpt-ad-${nowTime}-${randomNumber}`,
      isEmpty: false,
      isLoaded: false,
    }
    // defineSlot (EDD mode)
    if (props.adUnit && props.adUnitPath !== '' && props.adSize.length > 0) {
      this.defineEDDSlot()
    }
  }

  componentDidMount() {
    const { adElementId, isLoaded, slot } = this.state
    const { adUnitPath = '', adSize = [] } = this.props
    // DED mode.
    if (adElementId && (adUnitPath === '' || adSize.length === 0 || !slot)) {
      const isEmpty = this.checkEmptyiFrame(adElementId)
      if (isEmpty) this.displaySlot(adElementId)
      if (!isLoaded) this.setState((state) => ({ ...state, isLoaded: true }))
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.isLoaded !== nextState.isLoaded) {
      return true
    }
    if (this.state.isEmpty !== nextState.isEmpty) {
      return true
    }
    // default: false
    return false
  }

  insertDFPScript = () => {
    // insert async https://securepubads.g.doubleclick.net/tag/js/gpt.js script
    const searchScript =
      document.querySelector('script[src*="//securepubads.g.doubleclick.net/tag/js/gpt.js"]') ||
      null
    if (!searchScript) {
      const firstScript = document.getElementsByTagName('script')[0]
      const gptScript = document.createElement('script')
      gptScript.async = true
      gptScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
      firstScript.parentNode.insertBefore(gptScript, firstScript)
    }
  }

  defineEDDSlot = async () => {
    let slot = null
    const { adElementId } = this.state
    const {
      adUnit,
      adUnitPath,
      adSize,
      adTargeting,
      adAutoCollapse,
      onSlotRenderEnded,
      onImpressionViewable,
    } = this.props
    if (typeof window !== 'undefined') {
      //detect gpt.js
      await this.insertDFPScript()
      // googletag
      const googletag = window.googletag || {}
      googletag.cmd = googletag.cmd || []
      // exe cmd
      await googletag.cmd.push(async () => {
        // defineSlot here
        const fullPath = `/${adUnit}/${adUnitPath.replace(/^\//gi, '')}`
        slot = await googletag.defineSlot(fullPath, adSize, adElementId)
        // if no AD, retun null to cancel defineSlot.
        if (!slot) return null
        // adTargeting for White List or Black List
        Object.keys(adTargeting).forEach((key) => slot.setTargeting(key, adTargeting[key]))
        // impressionViewable trick it or not
        googletag.pubads().addEventListener('impressionViewable', (e) => {
          if (e.slot === slot) {
            // call onImpressionViewable
            if (typeof onImpressionViewable === 'function') onImpressionViewable(e)
          }
        })
        // slotRenderEnded
        googletag.pubads().addEventListener('slotRenderEnded', (e) => {
          if (e.slot === slot) {
            // check slot AD is empty or not.
            const isEmpty = !!e.isEmpty && this.checkEmptyiFrame(adElementId)
            // call onSlotRenderEnded
            if (typeof onSlotRenderEnded === 'function') onSlotRenderEnded(e)
            // check AD is empty or not
            this.setState((state) => ({ ...state, isEmpty }))
            // if is not Loaded
            if (!this.state.isLoaded) {
              // set isLoaded
              this.setState((state) => ({ ...state, isLoaded: true }))
            }
            // empty and masonryFocusUpdate
            if (isEmpty) this.masonryFocusUpdate()
          }
        })
        // addService and setCollapseEmptyDiv
        slot.addService(googletag.pubads())
        // true: div for this slot to be collapsed, after GPT detects that no ads are available for the slot.
        slot.setCollapseEmptyDiv(adAutoCollapse)
        // display
        googletag.display(adElementId)
        // update state
        this.setState((state) => ({ ...state, adElementId, slot }))
      })
    }
  }

  checkEmptyiFrame = (adElementId = '') => {
    if (!adElementId) return true
    const iFrame = document.querySelector(`#${adElementId} > div > iframe`)
    return !iFrame || (iFrame && iFrame.contentDocument.body.innerHTML.trim() === '')
  }

  displaySlot = (adElementId = '') => {
    if (adElementId && typeof window !== 'undefined') {
      const googletag = window.googletag || {}
      googletag.cmd = googletag.cmd || []
      googletag.cmd.push(() => googletag.display(adElementId))
    }
  }

  refreshSlot = (slot = null) => {
    if (slot && typeof window !== 'undefined') {
      const googletag = window.googletag || {}
      googletag.cmd = googletag.cmd || []
      googletag.cmd.push(() => googletag.pubads().refresh([slot]))
    }
  }

  masonryFocusUpdate = (delay = 300) => {
    if (typeof window !== 'undefined' && window.masonryFocusUpdate) {
      if (window.DFPWithMasonryFocusUpdate) window.clearTimeout(window.DFPWithMasonryFocusUpdate)
      window.DFPWithMasonryFocusUpdate = window.setTimeout(() => window.masonryFocusUpdate(), delay)
    }
  }

  render() {
    const { adElementId, isEmpty, isLoaded } = this.state
    const { adTagName: Tag, className, adStyle } = this.props
    const classNames = cx('default', className.split(' '), {
      isLoaded,
      isEmpty,
      isNotEmpty: !isEmpty,
      isMobile,
    })
    const style = Object.assign({}, adStyle)

    return (
      <Tag id={adElementId} className={classNames} style={style}>
        <style jsx>{styles}</style>
      </Tag>
    )
  }
}

export default DFP
